import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardFooter, CCol, CFormLabel, CRow } from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import {  CFormInput, CHeader } from '@coreui/react';
import { createMerchants, deleteMerchants, updateMerchants } from 'src/services/Merchants/Merchants';
import { CBadge } from '@coreui/react';
import { Toaster } from 'src/components/Toaster';

export default function MerchantActions() {
  const location = useLocation();
  const navigate = useNavigate();

  const [props, setProps] = useState(location.state ? [location.state] : []);
  const [address, setAddress] = useState(location.state?.merchantAddress ?? '');
  const [cityId, setCityId] = useState(location.state?.cityID ?? 1);
  const [countryId, setCountryId] = useState(location.state?.countryID ?? 1);
  const [latitude, setLatitude] = useState(location.state?.latitude ?? '');
  const [longitude, setLongitude] = useState(location.state?.longitude ?? '');
  const [name, setName] = useState(location.state?.merchantName ?? '');
  const [picName, setPicName] = useState(location.state?.picName ?? '');
  const [picPhone, setPicPhone] = useState(location.state?.picPhone ?? '');
  const [provinceId, setProvinceId] = useState(location.state?.provinceID ?? 1);
  const [subdistrictId, setSubdistrictId] = useState(
    location.state?.subdistrictID ?? 1
  );
  const [zip, setZip] = useState(location.state?.zip ?? 0);
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const [color, setColor] = useState("")

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('userDetail')).org_id !== 0) {
      navigate('/not-authorized');
    }
  }, []);

  async function handleOnClick(action) {
    if (action === 'Edit') {
      const data = {
        id: props[0].id,
        address: address,
        cityID: cityId,
        countryID: countryId,
        latitude: latitude,
        longitude: longitude,
        name: name,
        picName: picName,
        picPhone: picPhone,
        provinceID: provinceId,
        subdistrictID: subdistrictId,
        zip: zip
      };

      const update = await updateMerchants(data);

      if (update.success === 1) {
        setMessage(update.message)
        setOpen(true)
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(update.message)
        setOpen(true)
        setColor("red")
      }
    } else {
      const data = {
        address: address,
        cityID: cityId,
        countryID: countryId,
        latitude: latitude,
        longitude: longitude,
        name: name,
        picName: picName,
        picPhone: picPhone,
        provinceID: provinceId,
        subdistrictID: subdistrictId,
        zip: zip
      };

      const create = await createMerchants(data);

      if (create.success === 1) {
        setMessage(create.message)
        setOpen(true)
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(create.message)
        setOpen(true)
        setColor("red")
      }
    }
  }

    return (
        <>
            <CCard>
                <Toaster
                    open={open}
                    message={message}
                    setOpen={setOpen}
                    ahd={1500}
                    color={color ?? "red"}
                />
                <CHeader style={{marginLeft:"1vw"}}><strong>{JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Edit"} Merchant</strong></CHeader>

                <CCardBody style={{display:"flex", flexWrap:"wrap", width:"100%"}}>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Merchant Name <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={name} onChange={(e)=>{setName(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Merchant PIC Name <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={picName} onChange={(e)=>{setPicName(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Merchant PIC Phone</CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={picPhone} onChange={(e)=>{setPicPhone(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Address <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={address} onChange={(e)=>{setAddress(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Subdistrict ID <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={subdistrictId} type="number" onChange={(e)=>{setSubdistrictId(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>City ID <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={cityId} type="number" onChange={(e)=>{setCityId(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Province ID <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={provinceId} type="number" onChange={(e)=>{setProvinceId(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Country ID <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={countryId} type="number" onChange={(e)=>{setCountryId(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>ZIP <span><CBadge color="warning">Required</CBadge></span></CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={zip} type="number" onChange={(e)=>{setZip(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Latitude</CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={latitude} type="number" onChange={(e)=>{setLatitude(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                    <div style={{width:"100%", marginBottom:"2vh", marginRight:"3%", marginTop:"2vh"}}>
                        <CRow style={{width:"100%"}}>
                            <CCol xs={3}>
                                <CFormLabel>Longitude</CFormLabel>                        
                            </CCol>
                            <CCol xs={9}>
                                <CFormInput value={longitude} type="number" onChange={(e)=>{setLongitude(e.target.value)}}/>
                            </CCol>
                        </CRow>
                    </div>
                </CCardBody>
                <CCardFooter style={{textAlign:"right"}}>
                    <CButton style={{backgroundColor: "#4E5B97", border:"none", marginRight:"1vw"}}  onClick={()=>{handleOnClick(JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Edit")}}>{JSON.stringify(props) === JSON.stringify([]) ? "Add" : "Save"} Data</CButton>
                    {/* {JSON.stringify(props) === JSON.stringify([]) ? <></> : 
                        <CButton style={{backgroundColor: "red", border:"none"}} onClick={()=>{handleDelete()}}>Delete Data</CButton>
                    } */}
                </CCardFooter>
            </CCard>
        </>
    )
}
